import styled, { css } from "styled-components";

export const SwiperButtonBox = styled.div<{isTouchDevice?: boolean}>`
    margin: 0 0.5rem;

    ${({isTouchDevice}) => isTouchDevice ? css`
        display: none;
    ` : null}
`;
